import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfigDirective } from '../../directives/table-config.directive';

/**
 * Component to toggle the visiblity of mat-table columns
 * @example
 *
 * <ng-container
 *      liebherrTableConfig
 *      #tableConfig="liebherrTableConfig"
 *      [columnGroups]="columnGroups">
 * </ng-container>
 *
 * <liebherr-column-toggle [tableConfig]="tableConfig"></liebherr-column-toggle>
 *
 */

@Component({
    selector: 'liebherr-column-toggle',
    templateUrl: 'column-toggle.component.html',
    styleUrls: ['column-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnToggleComponent {
    /**
     * The TableConfigDirective this column toggle is connected to
     */
    @Input() tableConfig?: TableConfigDirective;
    /**
     * (optional) title displayed when hovering over menu button
     * @default 'TOGGLE_COLUMNS'
     */
    @Input() menuTitle = 'TOGGLE_COLUMNS';
    /**
     * (optional) title displayed when hovering over reset button
     * @default 'RESET'
     */
    @Input() resetTitle = 'RESET';
    /**
     * (optional) title displayed when hovering over submit button
     * @default 'SUBMIT'
     */
    @Input() submitTitle = 'SUBMIT';
    /**
     * (optional) color of the button
     * key of material theme palette
     * @default 'primary'
     */
    @Input() buttonColor: 'primary' | 'accent' | 'warn' = 'primary';
    /**
     * (optional) color of the selectors icon / checkbox
     * key of material theme palette
     * @default 'accent'
     */
    @Input() selectorColor: 'primary' | 'accent' | 'warn' = 'accent';
    /**
     * (optional) mat-icon of button
     * @default 'more_vert'
     */
    @Input() buttonIcon = 'more_vert';
    /**
     * (optional) mat-button type
     * @default 'flat'
     */
    @Input() buttonType: 'standard' | 'flat' | 'icon' = 'flat';
    /**
     * (optional) whether the the visibilty of the columns should be displayed via an icon or a checkbox
     * @default false
     */
    @Input() useCheckboxes = false;

    @Output() menuOpened = new EventEmitter();
    @Output() menuClosed = new EventEmitter();

    constructor() {}

    /**
     * @internal Method called on Item click
     */
    toggleColumn(column: string) {
        this.tableConfig?.toggleColumn(column);
    }
    /**
     * @internal Method called when to reset visiblity of table columns
     */
    onReset(event: MouseEvent) {
        event.stopPropagation();
        this.tableConfig?.reset();
    }
}
